/**
 * Strings for the deck editor (pages/DeckEditorPage.tsx, components/editor/
 * CardListPanel, CardListItem, CardEditorPanel). Spread into the main catalog;
 * `DECK_EDITOR_EN` is typed against `DECK_EDITOR_ES`, so a missing English
 * string fails to compile.
 *
 * The `deckEditor.delete*` confirmation strings and `deckEditor.saved` /
 * `deckEditor.loading` predate this file and live in catalog-system.ts.
 */

export const DECK_EDITOR_ES = {
  'deckEditor.fallbackName': 'Mazo',
  'deckEditor.count.one': '{count} tarjeta',
  'deckEditor.count.other': '{count} tarjetas',
  'deckEditor.newCard': 'Nueva tarjeta',
  'deckEditor.deleteChecked': 'Eliminar {count} seleccionadas',
  'deckEditor.checkCard': 'Seleccionar la tarjeta {n}',
  'deckEditor.saveChanges': 'Guardar cambios',
  'deckEditor.savedShort': 'Guardado',
  'deckEditor.deleteCard': 'Eliminar tarjeta',
  'deckEditor.saveError': 'Error al guardar: {error}',
  'deckEditor.resize.label': 'Redimensionar lista de tarjetas',
  'deckEditor.resize.hint': 'Arrastra para redimensionar · doble clic para restablecer',

  // Phone: list → one card, with the actions in a bar under the thumb
  'deckEditor.backToDeck': 'Volver al mazo',
  'deckEditor.backToList': 'Volver a la lista',
  'deckEditor.position': 'Tarjeta {n} de {total}',
  'deckEditor.mode.label': 'Editar la tarjeta o ver cómo queda',
  'deckEditor.mode.edit': 'Editar',
  'deckEditor.mode.preview': 'Ver',
  'deckEditor.save': 'Guardar',
  'deckEditor.new': 'Nueva',
  'deckEditor.actions': 'Acciones de la tarjeta',
} as const

export const DECK_EDITOR_EN: Record<keyof typeof DECK_EDITOR_ES, string> = {
  'deckEditor.fallbackName': 'Deck',
  'deckEditor.count.one': '{count} card',
  'deckEditor.count.other': '{count} cards',
  'deckEditor.newCard': 'New card',
  'deckEditor.deleteChecked': 'Delete {count} selected',
  'deckEditor.checkCard': 'Select card {n}',
  'deckEditor.saveChanges': 'Save changes',
  'deckEditor.savedShort': 'Saved',
  'deckEditor.deleteCard': 'Delete card',
  'deckEditor.saveError': 'Could not save: {error}',
  'deckEditor.resize.label': 'Resize the card list',
  'deckEditor.resize.hint': 'Drag to resize · double-click to reset',

  'deckEditor.backToDeck': 'Back to the deck',
  'deckEditor.backToList': 'Back to the list',
  'deckEditor.position': 'Card {n} of {total}',
  'deckEditor.mode.label': 'Edit the card or preview it',
  'deckEditor.mode.edit': 'Edit',
  'deckEditor.mode.preview': 'Preview',
  'deckEditor.save': 'Save',
  'deckEditor.new': 'New',
  'deckEditor.actions': 'Card actions',
}
